import type { DealEmail } from "@/types/deals.types";

export const emailStatusTone = (status: DealEmail["status"], statusLabel: string): "good" | "bad" | "muted" => {
  if (status === "failed" || statusLabel === "Bounced" || statusLabel === "Marked as spam") return "bad";
  if (status === "sent") return "good";
  return "muted";
};
